import PolicyMatrixGroup from "../components/PolicyMatrixGroup";

export default function PolicyMatrixPage() {
  return (
    <div className="max-w-4xl">
      <div className="mb-5">
        <h1 className="font-display text-3xl font-black tracking-tight text-slate-900">RAMS &amp; Policies</h1>
        <p className="font-body text-slate-600 mt-1 text-sm">Acknowledgement compliance across the active workforce. Counts overlap (an overdue item is also outstanding) and are never additive.</p>
      </div>
      <PolicyMatrixGroup defaultOpen title="Acknowledgement compliance" />
    </div>
  );
}
